import { useState } from 'react';

let id = 0;

export function usePropsSlugId(slugId?: string) {
  const [uid] = useState(() => `Un${id++}`);
  return slugId ?? uid;
}
